import request from './request'

export interface LoginUserData {
  id: number
  username: string
  nickname: string
  avatar: string
  role: string
}

export interface LoginData {
  token: string
  token_expires_in: number
  refresh_token: string
  refresh_token_expires_in: number
  user: LoginUserData
}

export interface LoginResponse {
  code: number
  msg: string
  data: LoginData
}

export const loginApi = (username: string, password: string): Promise<LoginResponse> => {
  return request.post('index.php/api/admin/login', { username, password })
}
